export var requiredSchemaVariables = [];
